import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorTitle: {
		id: 'servicedesk-insight-object-graph.graph-error.error-title',
		defaultMessage: 'Failed to load graph',
		description: 'Error message instructing user that the object graph did not load successfully',
	},
	errorDescription: {
		id: 'servicedesk-insight-object-graph.graph-error.error-description',
		defaultMessage: 'Please refresh the page and try again.',
		description:
			'Error description instructing user to refresh the page to try again after an error occurred.',
	},
});
export default messages;
